// The RM Lanes rows' lane-count view, modelled on Vertex's "lane count" style for the
// RM lanes layer (69634): colour by lane count, and the count written along the line.
// Vertex paints LR-sectioned ways a flat cyan; here styleBySection splits them, so every
// section gets its own count instead. Pure, so the node tests reach it.
import { isOffsetSectionedValue } from "./stepSections.mjs";

export const LANE_COUNT_COLORS = {
  1: "#e5402a",
  2: "#1f8f1f",
  3: "#4a5ff0",
  4: "#d39b52",
  5: "#e8c800", // 5 and up
  other: "#ff69b4", // no usable count
};

// A per-section scalar, or undefined. A raw LR chain only reaches here on
// styleBySection's whole-feature fallback, and is many values rather than one.
function scalar(value) {
  if (value === undefined || value === null) return undefined;
  const text = String(value).trim();
  if (text === "" || isOffsetSectionedValue(text)) return undefined;
  return text;
}

function colorFor(total) {
  if (!/^\d+$/.test(total ?? "")) return LANE_COUNT_COLORS.other;
  const n = Number(total);
  if (n === 0) return LANE_COUNT_COLORS.other;
  return LANE_COUNT_COLORS[Math.min(n, 5)];
}

/**
 * Plain JSON (styleBySection merges neighbouring sections by JSON.stringify).
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @returns {{color: string, label: string}|null} null when the way has no lane tags
 */
export function laneCountDescriptor(tags) {
  const total = scalar(tags.rm_lanesTotal);
  const parts = [
    total,
    scalar(tags.rm_lanesForward) && `F${scalar(tags.rm_lanesForward)}`,
    scalar(tags.rm_lanesBackward) && `B${scalar(tags.rm_lanesBackward)}`,
    scalar(tags.rm_lanesBothWays) && `BW${scalar(tags.rm_lanesBothWays)}`,
  ].filter(Boolean);
  if (parts.length === 0) return null;
  return { color: colorFor(total), label: parts.join("/") };
}
